import Vue from 'vue';

const CATCH_DATA = {}

// 获取所有的案由对应关系表
export async function getCourseCrime(params) {
  const key = JSON.stringify(params);
  if (CATCH_DATA[key]) return CATCH_DATA[key];
  const result = await Vue.prototype.httpPost('/sends/configure/search', {
    body: params
  });
  CATCH_DATA[key] = result.data;
  return result.data;
}

// 案件列表搜索
export async function getCaseCount(params) {
  const result = await Vue.prototype.httpPost('/nlp/case/count', params);
  return result.data.hits;
}

// 获取筛选弹框法律下拉
export async function getLawTree() {
  const key = 'getLawTree';
  if (CATCH_DATA[key]) return CATCH_DATA[key];
  const result = await Vue.prototype.httpGet('/nlp/case/law/tree');
  CATCH_DATA[key] = result.data;
  return result.data;
}

// 获取筛选弹框详细法律法规内容
export async function getFilterLaw(params) {
  const result = await Vue.prototype.httpPost('/nlp/case/law/search', params);
  return result.data;
}

// 获取法律法规下拉筛选内容
export async function getLawOptionSelect() {
  const result = await Vue.prototype.httpGet('/law/select');
  return result.data;
}

// 验证 identifyFlag 和 identifyKey
export async function postExternalLogin(params) {
  const result = await Vue.prototype.httpPost('user/external/login', params);
  return result.data;
}


// WEBPACK FOOTER //
// ./src/service/courseware.js